import React, { useContext } from 'react';

import { UploadApi } from '../apis';
import { api } from '../api';

const UploadApiContext = React.createContext(new UploadApi(api));

export const UploadApiProvider = UploadApiContext.Provider;
export const useUploadApi = (): UploadApi => useContext(UploadApiContext);
